import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderNavLink from './HeaderNavLink';
import classNames from 'classnames';

export class HeaderNavigation extends Component {
  static propTypes = {
    navList: PropTypes.arrayOf(
      PropTypes.shape({
        to: PropTypes.string.isRequired,
        className: PropTypes.string.isRequired,
        children: PropTypes.isRequired,
      })
    ).isRequired,
  };

  render() {
    return (
      <div className="header-aside navigation">
        {this.props.navList.map((item, i) => {
          return (
            <span key={i} className={classNames("navigation-cell", item.className, {'-active': item.active})}>
              <HeaderNavLink to={item.to} className={item.className}>
                {item.label}
              </HeaderNavLink>
            </span>
          );
        })}
      </div>
    );
  }
}
